<template>
  <div>
    <nav class="navbar shadow p-3 mb-5 bg-white rounded container-fluid" >
      <div class="row w-100">
        <div class="col-3 text-center d-none d-md-block">
          <img
            class="img-fluid"
            style="max-height:100px;"
            src="static/img/fime.jpeg"
            alt="Logo de la Facultad" />
        </div>
        <div class="col-6 pt-3 text-dark text-center d-none d-md-block">
          <h4>Exámen Psicométrico</h4>
          <h3 class="mb-0">Facultad de Ingeniería Mecánica y Eléctrica</h3>
        </div>
        <div class="col-3 text-center d-none d-md-block">
          <img
            class="img-fluid"
            style="max-height:100px;"
            src="static/img/logouanl.jpg"
            alt="Logo de la UANL" />
        </div>
      </div>
      <a class="navbar-brand mx-auto d-block d-md-none" href="#">
        <img class="img-fluid" src="static/img/fime.jpeg" alt="">
      </a>
    </nav>
    <div class="container mb-3">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      opcion_activa:'Login'
    }
  },
  methods:{
    Login(){
      this.opcion_activa='Login';
      this.$router.push({name:'Login'});
    }
  },
  created(){
    if (this.$route.name=='MenuPrincipal') {
      this.Login();
    }else{
      this.$router.push({name:this.$route.name});
    }
  }
};
</script>

<style scoped>
li.active{
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuPrincipal.vue